import type { CustomCellEditorProps } from 'ag-grid-react';
import { forwardRef } from 'react';
import { readableDate } from '../../utils/date';
import { NOW } from '../DateTimePicker';
import { DateTimePickerSelect } from '../DateTimePicker/DateTimePickerSelect';
import { FormControlSizes } from '../Form/types';

export const AgGridDateTimePicker = forwardRef(
  ({ value, onValueChange, api }: CustomCellEditorProps<any, Date | null, any>, ref) => {
    const handleChange = (newValue: Date | null) => {
      onValueChange(newValue);
      // Signal that editing is complete
      api.stopEditing();
    };

    return (
      <DateTimePickerSelect
        size={FormControlSizes.Small}
        value={value ?? null}
        prefix=""
        onChange={handleChange}
        shortcuts={{ [NOW]: 'Today' }}
        timePickerVariant="selector"
        showTimePicker={false}
        placeholder="Select Date"
        getLabel={value => (value ? readableDate(value) : '')}
        portalize={true}
      />
    );
  }
);
